import React, { FC, memo } from 'react';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

import { TEXTS } from '../../texts';

interface SuccessActionButtonProps {
  showStreamsButton: boolean;
  showWebPlayerButton: boolean;
  onChangeStreamClick: () => void;
  onOpenWebPlayerClick: () => void;
  onClose: () => void;
}

const SuccessActionButton: FC<SuccessActionButtonProps> = ({
  showStreamsButton,
  showWebPlayerButton,
  onChangeStreamClick,
  onOpenWebPlayerClick,
  onClose,
}) => {
  if (showStreamsButton) {
    return (
      <Button
        elementId="button_open_streams_success_modal"
        type={ButtonType.PRIMARY}
        onClick={onChangeStreamClick}>
        {TEXTS.MODAL_BIND_SUCCESS_BUTTON_OPEN_STREAMS_TEXT}
      </Button>
    );
  }

  if (showWebPlayerButton) {
    return (
      <Button
        elementId="button_open_web_player_bind_success_modal"
        type={ButtonType.PRIMARY}
        onClick={onOpenWebPlayerClick}>
        {TEXTS.MODAL_BIND_SUCCESS_BUTTON_OPEN_WEB_PLAYER_TEXT}
      </Button>
    );
  }

  return (
    <Button
      elementId="button_change_device_success_modal"
      type={ButtonType.PRIMARY}
      onClick={onClose}>
      {TEXTS.MODAL_BIND_SUCCESS_BUTTON_CLOSE_TEXT}
    </Button>
  );
};

export default memo(SuccessActionButton);
